import axios from "axios";
import { errorToast } from "../../react-toastfiy/toast";

class ChannelFinanceService {
  GetChannelFinanceDataById = async (formdata, source = {}) => {
    return axios({
      method: "post",
      url: `/users/get-channel-finance-data-by-id`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetListOfChannelFinanceForRisk = async (formdata, source = {}) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-for-risk`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  RiskTempChannelFinanceFileUpload = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/risk-temp-channel-finance-file-upload`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetListOfChannelFinanceForAuctionAdmin = async (formdata, source = {}) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-for-auction-admin`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  AuctionAdminTempChannelFinanceFileUpload = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/auction-admin-temp-channel-finance-file-upload`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  RiskChannelFinanceSellerUTRUpdate = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/risk-channel-finance-seller-utr-update`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  SendTADisbursementSellerEmail = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/send-ta-disbursement-seller-email`,
      data: JSON.stringify(formdata),
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  RiskChannelFinanceReleaseOrderPendingList = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-release-order`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  RiskChannelFinanceReleaseOrderUpload = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/channel-finance-release-order-upload`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  ChannelFinanceRejection = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/temp-channel-finance-rejection`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetListOfChannelFinanceStockInward = async (formdata, source = {}) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-stock-inward`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetListOfChannelFinanceYardOwnerUploadedDataVerification = async (
    formdata
  ) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-yard-owner-uploaded-data-verification`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  ChannelFinanceYardOwnerUploadedDataVerification = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/channel-finance-yard-owner-uploaded-data-verification`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  StockInwardReceiptUpload = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/stock-inward-receipt-upload`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  ChannelFinanceFileSave = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/channel-finance-file-save`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  ChannelFinanceCollectMoneyFromBuyer = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/cf-collect-money-from-buyer`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  ChannelFinanceStockInwardReceiptUpload = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/stock-inward-receipt-upload`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  ChannelFinanceUserStateWiseData = async (formdata) => {
    return axios({
      method: "get",
      url: `/users/channel-financed-user-state-wise-data`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  CreateUser = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/create-channel-finance-case`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  UpdateUser = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/update-channel-finance-case`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetUserExists = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/get-user-data-by-phone`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetListAppliedForChannelFinanceCase = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-applied-for-channel-finance-cases`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetChannelFinanceApprovalList = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/get-all-docs-verification-pending-completed-by-accounts-team`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  DocsApprovalAndReject = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/verification-or-updation-of-channel-finance-case`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetAllDocsVerificationPendingCompletedByBusinessAnalyst = async (
    formdata
  ) => {
    return axios({
      method: "post",
      url: `/users/get-all-docs-verification-pending-completed-by-business-analyst-team`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetAllApprovalPendingCompletedbyAdminAPI = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/get-all-docs-approval-pending-completed-by-admin`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetAllApprovalPendingCompletedbyFinancier = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/get-all-docs-approval-pending-completed-by-financier`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetAllPhysicalDocumentsPendingCollected = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/get-all-physical-documents-pending-collected`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetAllPhysicalDocumentsPendingCollectedByAR = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/get-all-physical-documents-pending-collected-by-AR`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetAllAgreementSignedPendingCompleted = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/get-all-agreement-signed-pending-completed`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetSendCreditLimitAndSanctionLatter = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/credit-limit-and-sanction-letter`,
      data: formdata,
      //   headers: {
      //     "content-type": "application/json",
      //   },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetBidderChannelFinanceCaseList = async (formData, source = {}) => {
    return axios({
      method: "post",
      url: `/users/get-bidder-channel-finance-case-list`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  SaveOtpForMmfsl = async (formData) => {
    return axios({
      method: "post",
      url: `/users/cf-save-otp-for-mmfsl`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetTAMmfslOtpList = async (formData, source = {}) => {
    return axios({
      method: "post",
      url: `/users/get-ta-mmfsl-otp-list`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetTADashboardSummary = async (formData, source = {}) => {
    return axios({
      method: "post",
      url: `/users/get-ta-dashboard-summary`,
      data: formData,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GlobalDataCountAPIChannelFinanceForAccount = async (formData) => {
    return axios({
      method: "get",
      url: `users/get-all-docs-verification-pending-completed-by-accounts-team-count`,
      data: formData,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GlobalDataCountAPIChannelFinanceForSuperAdmin = async (formData) => {
    return axios({
      method: "get",
      url: `users/get-all-docs-approval-pending-completed-by-admin-count`,
      data: formData,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GlobalDataCountAPIChannelFinanceForBA = async (formData) => {
    return axios({
      method: "post",
      url: `users/get-all-docs-verification-pending-completed-by-business-analyst-team`,
      data: formData,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };
  GlobalDataCountAPIChannelFinanceForRisk = async (formData) => {
    return axios({
      method: "post",
      url: `users/get-all-agreement-signed-pending-completed`,
      data: formData,
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  ChannelFinanceRejectCase = async (formData) => {
    return axios({
      method: "post",
      url: `users/risk-channel-finance-reject-case`,
      data: formData,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetChannelFianceUploadedPaymentProofList = async (formData) => {
    return axios({
      method: "post",
      url: `/users/get-cf-uploaded-payment-proof-list`,
      data: formData,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  CFVerifyPaymentProof = async (formData) => {
    return axios({
      method: "post",
      url: `users/cf-verify-payment-proof`,
      data: formData,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  MTReleaseOrderUpload = async (formData) => {
    return axios({
      method: "post",
      url: `users/mt-release-order-upload`,
      data: formData,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetListOfChannelFinanceMTReleaseOrder = async (formData) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-mt-release-order`,
      data: formData,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  GetListOfChannelFinancePODNumber = async (formData, signal) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-pod-number`,
      data: formData,
      signal,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        if (axios.isCancel(error)) return;
        console.log(error);
      });
  };

  PODNumberUpload = async (formData) => {
    return axios({
      method: "post",
      url: `/users/pod-number-upload`,
      data: formData,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetCFLoanBifurcation = async (formData) => {
    return axios({
      method: "post",
      url: `/users/get-cf-loan-bifurcation`,
      data: formData,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  CFUploadPaymentProof = (formData) => {
    return axios({
      method: "post",
      url: `/users/cf-upload-payment-proof`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetListOfChannelFinanceManageYardDownPayment = async (formData, {}) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-manage-yard-down-payment`,
      data: formData,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        errorToast(error?.message);
      });
  };

  SubmitYardDownPaymentDetails = async (formData) => {
    return axios({
      method: "post",
      url: `/users/submit-yard-down-payment-details`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  SubmitTAContactEmails = async (formData) => {
    return axios({
      method: "post",
      url: `/users/submit-ta-contact-emails`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetOPCPhysicalAvailabilityList = async (formData, signal) => {
    return axios({
      method: "post",
      url: `/users/get-opc-physical-availability-list`,
      data: formData,
      signal,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        if (axios.isCancel(error)) return;
        console.log(error);
      });
  };

  GetOPCPhysicalAvailabilityPendingCount = async () => {
    return axios({
      method: "post",
      url: `/users/get-opc-physical-availability-pending-count`,
      headers: { "content-type": "application/json" },
      data: JSON.stringify({}),
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  SubmitOPCPhysicalAvailability = async (formData) => {
    return axios({
      method: "post",
      url: `/users/submit-opc-physical-availability`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  SubmitOPCPhysicalAvailabilityFollowUp = async (formData) => {
    return axios({
      method: "post",
      url: `/users/submit-opc-physical-availability-followup`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  SubmitOPCPhysicalAvailabilityScheduleFollowUp = async (formData) => {
    return axios({
      method: "post",
      url: `/users/submit-opc-physical-availability-schedule-followup`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetOPCStockInwardPendingList = async (formData, signal) => {
    return axios({
      method: "post",
      url: `/users/get-opc-stock-inward-pending-list`,
      data: formData,
      signal,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        if (axios.isCancel(error)) return;
        console.log(error);
      });
  };

  GetOPCStockInwardPendingCount = async () => {
    return axios({
      method: "post",
      url: `/users/get-opc-stock-inward-pending-count`,
      headers: { "content-type": "application/json" },
      data: JSON.stringify({}),
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetListOfChannelFinanceProcessingFeeChangeApproval = async (formData) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-processing-fee-change-approval`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  SubmitProcessingFee = async (formData) => {
    return axios({
      method: "post",
      url: `/users/submit-processing-fee`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetListOfChannelFinancePaymentApproval = async (formData) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-payment-approval`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  ChannelFinancePaymentApproval = async (formData) => {
    return axios({
      method: "post",
      url: `/users/channel-finance-payment-approval`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  SubmitProcessingFeeChangeRequest = async (formData) => {
    return axios({
      method: "post",
      url: `/users/submit-processing-fee-change-request-ASA`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetListOfChannelFinanceForSellerUTRUpdate = async (formData) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-for-seller-utr-update`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetListOfChannelFinanceForSellerEmail = async (status) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-for-seller-email`,
      headers: { "content-type": "application/json" },
      data: JSON.stringify({ status }),
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetDisbursementSellerEmailPendingCount = async () => {
    return axios({
      method: "post",
      url: `/users/get-disbursement-seller-email-pending-count`,
      headers: { "content-type": "application/json" },
      data: JSON.stringify({}),
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetAllTradeAdvanceCases = async (formData) => {
    return axios({
      method: "get",
      url: `/users/get-all-trade-advance-cases`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  CFRequestForPayment = async (formData) => {
    return axios({
      method: "post",
      url: `/users/cf-request-for-payment`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetCFRequestedForPaymentListASA = async (formData) => {
    return axios({
      method: "post",
      url: `/users/get-cf-requested-for-payment-list-ASA`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetCFRequestedForPaymentListRisk = async (formData) => {
    return axios({
      method: "post",
      url: `/users/get-cf-requested-for-payment-list-RISK`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  CFPaymentRequestApprovalReject = async (formData) => {
    return axios({
      method: "post",
      url: `/users/cf-payment-request-approval-reject`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  DeleteCFTransaction = async (formData) => {
    return axios({
      method: "post",
      url: `/users/delete-cf-txn`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetListOfChannelFinanceRejectedPayment = async (formData) => {
    return axios({
      method: "post",
      url: `/users/get-list-of-channel-finance-rejected-payment`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  UpdateRejectedPayment = async (formData) => {
    return axios({
      method: "post",
      url: `/users/update-rejected-payment`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  ResendCreditRequestLetterForSignature = async (formData) => {
    return axios({
      method: "post",
      url: `/users/retry-crl-for-ta`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetCFFinancierRepaymentList = async (formData) => {
    return axios({
      method: "post",
      url: `/users/get-cf-financier-repayment-list`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  CFFinancierPartRepaymentUploadPaymentProof = async (formData) => {
    return axios({
      method: "post",
      url: `/users/cf-financier-part-repayment-upload-payment-proof`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  MarkFinancierPartRepaymentDone = async (formData) => {
    return axios({
      method: "post",
      url: `/users/mark-financier-part-repayment-done`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetTATotalFinancedVehiclesDetails = async (formData) => {
    return axios({
      method: "post",
      url: `/users/get-ta-total-financed-vehicles-details`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  GetTAOnBoardingDashboardData = async (formData) => {
    return axios({
      method: "get",
      url: `/users/get-ta-onboarding-dashboard-data-for-sa`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetTAOnBoardingUploadedDocuments = async (formData) => {
    return axios({
      method: "post",
      url: `/users/get-taonboard-uploaded-documents`,
      data: formData,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetTAOutstandingAmountExcludeWeekends = (formData) => {
    return axios({
      method: "post",
      url: `/users/get-ta-outstanding-amount-exclude-weekends`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  CFAddPaymentForRISK = async (formData) => {
    return axios({
      method: "post",
      url: `/users/cf-add-payment-for-risk`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetTAFinancierList = async () => {
    return axios({
      method: "get",
      url: `/users/api/ta-financier/list`,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  UpdateTAFinancier = async (formdata) => {
    return axios({
      method: "post",
      url: `/users/api/channel-finance/update-ta-financier`,
      data: formdata,
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  GetCFPnLCases = async (params = {}, source = {}) => {
    return axios({
      method: "get",
      url: `/users/api/master-ledger/trade-advance/pnl/cases`,
      params,
      cancelToken: source?.token,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  DownloadCFPnLExcel = async (params = {}) => {
    return axios({
      method: "get",
      url: `/users/api/master-ledger/trade-advance/pnl/excel`,
      params,
      responseType: "blob",
    });
  };

  GetCFPenaltyConfigBuyerList = async (source = {}) => {
    return axios({
      method: "get",
      url: `/users/api/cf-penalty-config/buyers/`,
      cancelToken: source?.token,
    })
      .then((response) => response.data)
      .catch((error) => console.log(error));
  };

  UpdateCFPenaltyConfig = async (formdata, source = {}) => {
    return axios({
      method: "post",
      url: `/users/api/cf-penalty-config/update/`,
      data: formdata,
      headers: { "content-type": "application/json" },
      cancelToken: source?.token,
    })
      .then((response) => response.data)
      .catch((error) => console.log(error));
  };

  GetCFPenaltyCaseList = async (buyerId, source = {}) => {
    return axios({
      method: "get",
      url: `/users/api/cf-penalty-config/case-list/?buyer_id=${buyerId}`,
      cancelToken: source?.token,
    })
      .then((response) => response.data)
      .catch((error) => console.log(error));
  };

  GetCFPenaltyAuditLog = async (params = {}, source = {}) => {
    return axios({
      method: "get",
      url: `/users/api/cf-penalty-config/audit-log/`,
      params,
      cancelToken: source?.token,
    })
      .then((response) => response.data)
      .catch((error) => console.log(error));
  };
  
  GetCFDayBook = async (cfId, source = {}) => {
    return axios({
      method: "get",
      url: `/users/api/master-ledger/trade-advance/day-book/${cfId}/`,
      cancelToken: source?.token,
    });
  };

  DownloadCFDayBookExcel = async (cfId) => {
    return axios({
      method: "get",
      url: `/users/api/master-ledger/trade-advance/day-book/excel`,
      params: { cf_id: cfId },
      responseType: "blob",
    });
  };

  CreateEarlyRepaymentRequest = async (formdata) => {
    const form_data = new FormData();
    Object.keys(formdata).forEach((key) => form_data.append(key, formdata[key]));
    return axios({
      method: "post",
      url: `/users/cf-early-repayment-request-create`,
      headers: { "content-type": "multipart/form-data" },
      data: form_data,
    });
  };

  GetEarlyRepaymentRequestList = async (formdata) => {
    const form_data = new FormData();
    Object.keys(formdata).forEach((key) => form_data.append(key, formdata[key]));
    return axios({
      method: "post",
      url: `/users/cf-early-repayment-request-list`,
      headers: { "content-type": "multipart/form-data" },
      data: form_data,
    });
  };

  ReviewEarlyRepaymentRequest = async (formdata) => {
    const form_data = new FormData();
    Object.keys(formdata).forEach((key) => form_data.append(key, formdata[key]));
    return axios({
      method: "post",
      url: `/users/cf-early-repayment-request-review`,
      headers: { "content-type": "multipart/form-data" },
      data: form_data,
    });
  };

  // Generate (or fetch existing) Sale Purchase Invoice for a Trade Advance case
  GenerateTASaleInvoice = async (cfId) => {
    return axios({
      method: "post",
      url: `/users/api/master-ledger/trade-advance/cases/${cfId}/sale-invoice/`,
    })
      .then((response) => response.data)
      .catch(function (error) {
        console.log(error);
      });
  };

  // Edit who the TA sale invoice is billed to (name / PAN / phone override)
  UpdateTABuyerInvoiceDetails = async (formData) => {
    return axios({
      method: "post",
      url: `/users/update-ta-sale-invoice-buyer-details`,
      data: formData,
    })
      .then((response) => response.data)
      .catch(function (error) {
        console.log(error);
        return { status: 500, msg: error?.message || "Something went wrong" };
      });
  };

  // Download the sale purchase invoice PDF via the authenticated backend
  // proxy — the S3 bucket is private, so this is the only way to fetch it.
  DownloadTASaleInvoice = async (cfId) => {
    return axios({
      method: "get",
      url: `/users/api/master-ledger/trade-advance/cases/${cfId}/sale-invoice/download/`,
      responseType: "blob",
    });
  };

  // Bulk download a ZIP of Sale Purchase Invoice PDFs for the P&L page's
  // currently filtered cases (same date/state/financier filters as
  // GetCFPnLCases).
  BulkDownloadTASaleInvoices = async (params = {}) => {
    return axios({
      method: "get",
      url: `/users/api/master-ledger/trade-advance/pnl/sale-invoices/bulk-download/`,
      params,
      responseType: "blob",
    });
  };

  // State x stage grid of everything currently pending across the four OPC
  // queues. Counts come straight from each worklist's own gate, so this always
  // reconciles with the sidebar badges.
  GetOPCPendingWorkSummary = async (signal) => {
    return axios({
      method: "post",
      url: `/users/get-opc-pending-work-summary`,
      headers: { "content-type": "application/json" },
      data: JSON.stringify({}),
      signal,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        if (axios.isCancel(error)) return;
        console.log(error);
      });
  };

  // Paginated drill-down behind one cell of the pending-work grid.
  GetOPCPendingWorkCases = async (formData, signal) => {
    return axios({
      method: "post",
      url: `/users/get-opc-pending-work-cases`,
      data: formData,
      signal,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        if (axios.isCancel(error)) return;
        console.log(error);
      });
  };

  // State x step grid of everything currently pending across the whole TA case
  // flow (all 10 pipeline steps, including the three parallel OPC stages).
  // `groupBy` is 'state' (default) or 'user' -- rows come back keyed by
  // group_key/group_label instead of (or alongside) state.
  // arPhone: only ever sent for an Auction Representative -- see
  // TACaseFlowPendingDashboard's isAuctionRepresentative() check. Every other
  // role passes null/undefined here and the board stays org-wide, matching
  // the backend default when ar_phone is absent.
  GetTACaseFlowPendingSummary = async (groupBy = "state", arPhone = null, signal) => {
    // FormData, not JSON: Django reads params off request.POST, which only
    // parses form-encoded and multipart bodies. A JSON body arrives with
    // request.POST empty, so group_by is dropped and the view silently falls
    // back to state grouping.
    const formData = new FormData();
    formData.append("group_by", groupBy || "state");
    if (arPhone) formData.append("ar_phone", arPhone);
    return axios({
      method: "post",
      url: `/users/get-ta-case-flow-pending-summary`,
      data: formData,
      signal,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        if (axios.isCancel(error)) return;
        console.log(error);
      });
  };

  // Paginated drill-down behind one cell of the TA case flow grid.
  GetTACaseFlowPendingCases = async (formData, signal) => {
    return axios({
      method: "post",
      url: `/users/get-ta-case-flow-pending-cases`,
      data: formData,
      signal,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        if (axios.isCancel(error)) return;
        console.log(error);
      });
  };

  GetTACaseTrackInfo = async (formData, signal) => {
    return axios({
      method: "post",
      url: `/users/get-ta-case-track-info`,
      data: formData,
      signal,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        if (axios.isCancel(error)) return;
        console.log(error);
      });
  };

  GetTACaseSuggestions = async (formData, signal) => {
    return axios({
      method: "post",
      url: `/users/get-ta-case-suggestions`,
      data: formData,
      signal,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        if (axios.isCancel(error)) return;
        console.log(error);
      });
  };
}

export default new ChannelFinanceService();
